import { render } from "./CredentialForm.vue?vue&type=template&id=2c187ff0"
import script from "./CredentialForm.vue?vue&type=script&lang=js"
export * from "./CredentialForm.vue?vue&type=script&lang=js"

import "./CredentialForm.vue?vue&type=style&index=0&id=2c187ff0&lang=css"

import exportComponent from "C:\\Users\\lenovo\\Desktop\\canadianlic\\client\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__